<template>
    <div class="specialAdd">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>市场专题</el-breadcrumb-item>
            <el-breadcrumb-item>添加专题</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="special-add-box">
            <el-form :model="addSpecialForm" :rules="validateRules" ref="addSpecialForm" label-width="100px" class="addSpecialForm">
                <el-form-item label="专题名称" prop="specialName">
                    <el-input v-model="addSpecialForm.specialName" auto-complete="off" placeholder="请输入专题名称"></el-input>
                </el-form-item>
                <el-form-item label="投放公司" prop="company">
                    <el-input v-model="addSpecialForm.company" auto-complete="off" placeholder="请输入投放公司"></el-input>
                </el-form-item>
                <el-form-item label="执行者" prop="createUser">
                    <el-select class="selectForm" v-model="addSpecialForm.createUser" placeholder="请选择执行者">
                        <el-option v-for="userItem in userList" :key="userItem.userId" :label="userItem.userName" :value="userItem.userId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="焦点图" prop="focusImgUrl">
                    <el-input v-model="addSpecialForm.focusImgUrl" auto-complete="off" placeholder="请输入焦点图地址"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="specialContent">
                    <el-input v-model="addSpecialForm.specialContent" type="textarea" auto-complete="off" placeholder="请输入专题描述（选填）"></el-input>
                </el-form-item>
                <el-form-item label="开启分享" prop="isShare">
                    <el-switch v-model="addSpecialForm.isShare" on-value="1" off-value="0">
                    </el-switch>
                </el-form-item>
                <template v-if="Number(addSpecialForm.isShare)">
                    <el-form-item label="分享链接" prop="shareUrl">
                        <el-input v-model="addSpecialForm.shareUrl" auto-complete="off" placeholder="请输入分享链接（选填）"></el-input>
                    </el-form-item>
                    <el-form-item label="分享图（尺寸200*200）" prop="shareImgUrl">
                        <el-input v-model="addSpecialForm.shareImgUrl" auto-complete="off" placeholder="请输入分享图地址"></el-input>
                    </el-form-item>
                    <el-form-item label="分享标题" prop="shareTitle">
                        <el-input v-model="addSpecialForm.shareTitle" auto-complete="off" placeholder="请输入分享标题"></el-input>
                    </el-form-item>
                    <el-form-item label="分享描述" prop="shareDes">
                        <el-input v-model="addSpecialForm.shareDes" type="textarea" auto-complete="off" placeholder="请输入分享描述（选填）"></el-input>
                    </el-form-item>
                </template>
                <el-form-item>
                    <el-button type="primary" @click="addSpecial('addSpecialForm')">立即创建</el-button>
                    <el-button @click="clearSpecialData()">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="special-preview-box">
                <div class="header-image" v-if="addSpecialForm.focusImgUrl !== null && addSpecialForm.focusImgUrl !== ''">
                    <img :src="addSpecialForm.focusImgUrl" alt="请输入正确的图片地址">
                </div>
                <div class="description" v-if="addSpecialForm.specialContent !== null && addSpecialForm.specialContent !== ''">
                    <div class="desc-icon">概述</div>
                    <span class="desc-content">{{addSpecialForm.specialContent}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "specialAdd",
    data() {
        return {
            addSpecialForm: {
                specialName: '',
                company: '',
                createUser: '',
                specialId: -1,
                specialContent: '',
                focusImgUrl: '',
                isShare: '0',
                shareTitle: '',
                shareDes: '',
                shareUrl: '',
                shareImgUrl: ''
            },
            userList: null,
            validateRules: {
                specialName: [
                    { required: true, message: '请填写专题标题', trigger: 'change' }
                ],
                company: [
                    { required: true, message: '请填写投放公司', trigger: 'change' }
                ],
                createUser: [
                    { required: true, type: 'number', message: '请选择执行者', trigger: 'change' }
                ],
                focusImgUrl: [
                    { required: true, message: '请填写焦点图地址', trigger: 'change' }
                ],
                shareTitle: [
                    { required: true, message: '请填写分享标题', trigger: 'change' }
                ],
                shareImgUrl: [
                    { required: true, message: '请填写分享图片地址', trigger: 'change' }
                ]
            }
        };
    },
    mounted() {
        this._init();
    },
    methods: {
        _getUserList() {
            this.$http.get(CONFIG.HOST + "/users/list" + '?t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.userList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _confirmMessage(message, success = () => { }, cancel = () => { }) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);
        },
        addSpecial(formName) {
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                this.$notify.error({
                    message: '请检查要添加的数据'
                });
                return;
            }
            this.addSpecialForm.isShare = Number(this.addSpecialForm.isShare); 
            this.$http.post(CONFIG.HOST + '/superSpecial/add', this.addSpecialForm).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】市场专题创建成功'
                    });
                    this.clearSpecialData();
                    // router.push({
                    //     name: 'businessList'
                    // });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        clearSpecialData() {
            this.$refs.addSpecialForm.resetFields();
        },
        _init() {
            this._getUserList();
        }
    }
};
</script>
<style lang="less">
.specialAdd {
    width: 98%;
    margin: 0 auto;
    .el-form-item__label {
        font-weight: bold;
    }
    .el-switch {
        position: absolute;
        left: 0;
        top: 7px;
    }
    .bread-nav {
        margin: 20px 0;
    }
    .special-add-box {
        width: 980px;
        position: relative;
        left: 0;
        top: 0;
        .addSpecialForm {
            width: 440px;

            position: absolute;
            left: 0;
            top: 0;

            .selectForm {
                width: 100%;
            }
        }
        .special-preview-box {
            width: 360px;
            height: 540px;
            border: 1px solid #bfcbd9;
            border-radius: 6px;

            position: absolute;
            left: 550px;
            top: 0;

            .header-image {
                width: 100%;
                display: block;
                img {
                    width: 100%;
                }
            }
            .description {
                padding: 0 11px;
                font-size: 10px;
                text-align: left;
                .desc-icon {
                    color: #fff;
                    background: #0c9aee;
                    display: inline-flex;
                    padding-left: 2px;
                    padding-right: 2px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// Add.vue?1d99fec5